import React from 'react';
import SvgIcon from './SvgIcon';

const ArrowTaleRight = props => (
    <SvgIcon viewBox="0 0 24 24" fill="none" {...props}>
        <path
            d="M18.75 12H5.25M13.5 6.75L18.75 12l-5.25 5.25"
            stroke="currentColor"
            strokeMiterlimit={10}
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);

ArrowTaleRight.displayName = 'ArrowTaleRightIcon';

export default ArrowTaleRight;
